/// <reference path="../../ng-services/chat.service.ts"/>

import { Meeting } from '../../models/chat';
import { ChatCurrentlyTypingService } from '../../ng-services/chat-currently-typing.service';

(function () {
    class ChatCurrentlyTypingComponent {
        static $inject = ['ChatCurrentlyTypingService', '$timeout'];

        public conversation!: Meeting;

        private subscribes: Rx.IDisposable[] = [];

        private usersTyping?: string[];

        constructor(
            private chatCurrentlyTypingService: ChatCurrentlyTypingService,
            private $timeout: angular.ITimeoutService
        ) {}

        $onDestroy() {
            this.subscribes.forEach((d) => d.dispose());
        }

        $onInit() {
            this.subscribes = [
                this.chatCurrentlyTypingService.usersTypingInMeeting$(this.conversation.id).subscribe((users) => {
                    // Sometimes the store changes not in the context of a digest, need to force that
                    // with a dummy timeout
                    this.$timeout((scope) => {
                        this.usersTyping = [...users].map((userId) => {
                            // The participant may not exist if they joined AFTER the meeting was loaded
                            return this.conversation?.participants?.[userId]?.short_name || `someone`;
                        });
                    });
                }),
            ];
        }
    }

    angular.module('tradersyard').component('tyChatCurrentlyTypingIndicator', {
        template: `<div class="chat_currently_typing_indicator">
            <div ng-if="$ctrl.usersTyping.length == 1">
                <i class="fa fa-keyboard"></i>
                <strong>{{$ctrl.usersTyping[0]}}</strong>
                is typing...
            </div>
            <div ng-if="$ctrl.usersTyping.length > 1 && $ctrl.usersTyping.length < 4">
                <i class="fa fa-keyboard"></i>
                <strong>{{$ctrl.usersTyping.slice(0, -1).join(', ')}}</strong>
                and
                <strong>{{$ctrl.usersTyping.slice(-1)[0]}}</strong>
                are typing...
            </div>
            <div ng-if="$ctrl.usersTyping.length >= 4">
                <i class="fa fa-keyboard"></i>
                <strong>{{$ctrl.usersTyping.length}} people</strong>
                are typing...
            </div>
        </div>`,
        controller: ChatCurrentlyTypingComponent,
        bindings: {
            conversation: '<',
        },
    });
})();
